export function getPropValue(obj:any, prop:any) {
  return obj[prop];
}
